/**
 * PC pseudo box shared constants
 */
export const PC_PSEUDO_VIEWBOX = '0 0 307 100';
